import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormJBPHPContactRoles } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { useEffect, useState } from 'react'

import MeasureController from 'core/analytics/MeasureController'
import { useMeasureController } from 'core/analytics/useMeasureController'
import { CrudStore } from 'core/types/crudStore'

export const useSalesTeamRoles = (metrics: MeasureController) => {
  /** -------------------- Variables ----------------------- */
  const [allRoles, setAllRoles] = useState<IFormJBPHPContactRoles[]>([])
  const { startLoadData, stopLoadData } = useMeasureController(metrics)

  const allRolesCrud = CrudStore.get(
    CrudStoreItemPartner360.SalesTeamRoles,
    'SalesTeamRoles-allRoles'
  )

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    startLoadData()

    allRolesCrud.fetch().then((result) => {
      setAllRoles(result.items)
    })

    stopLoadData()
  }, [startLoadData, stopLoadData, allRolesCrud])

  return allRoles
}
